import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "circular-loader",
  viewBox: "25 25 50 50"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "loader-path",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    "stroke-width": "2"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader", _ctx.loaderClass ? _ctx.loaderClass : ''])
  }, _hoisted_2, 2))
}